module.exports = __webpack_public_path__ + "img/Mask-group2.0d29c864.png";